const MessageTypes = {
    TEXT: 'text',
    IMAGE: 'image',
    ATTACHMENT: 'attachment',
    QUOTE_REQUEST: 'quote-request',
};

export { MessageTypes };
